import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const IsOpenPriceCheckbox: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = restaurantForFullInfo?.isOpenPriceServiceCharge || false;
	const inputValue = isChecked ? t('yes') : t('no');

	return (
		<FullInfoField
			label="openPriceLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
